module.exports = __webpack_public_path__ + "static/media/Swing - S'en aller feat. Angèle (lyrics video).7d599330.mp3";